<template>
  <div class="smenu">
    <ul class="menu-back">
      <li><a @click="$router.go(-1)"><i class="smenu-icon fas fa-arrow-circle-left fa-fw"></i> Voltar</a></li>
    </ul>
    <ul>
      <page-menu-item label="Projetos" icon="fal fa-book fa-fw fa-fw" :route="{name: 'suporte.projetos'}"/>
    </ul>
  </div>
</template>

<script>
import PageMenuItem from "components/suporte/components/include/PageMenuItem"

export default {
  name: "MenuProjetos",
  inject: ['page'],
  components: {
    PageMenuItem,
  }
}
</script>
